module.exports = __webpack_public_path__ + "21f635041d9fda4e2896a1e0420dcce1.svg";